import { useState } from 'preact/hooks'
import { WIDGET_CONFIG } from '../config'

interface FeedbackViewProps {
  onBack: () => void
  onSubmit: (text: string) => Promise<void>
}

export function FeedbackView({ onBack, onSubmit }: FeedbackViewProps) {
  const [text, setText] = useState('')
  const [status, setStatus] = useState<'idle' | 'submitting' | 'sent'>('idle')

  async function handleSubmit() {
    if (!text.trim() || status === 'submitting') return
    setStatus('submitting')
    await onSubmit(text)
    setStatus('sent')
  }

  if (status === 'sent') {
    return (
      <div class="spotlight-feedback-view">
        <div class="spotlight-feedback-success">
          <div class="spotlight-feedback-success-icon">{WIDGET_CONFIG.copy.feedbackSuccessIcon}</div>
          <div class="spotlight-feedback-success-title">{WIDGET_CONFIG.copy.feedbackSuccessTitle}</div>
          <div class="spotlight-feedback-success-sub">{WIDGET_CONFIG.copy.feedbackSuccessSub}</div>
        </div>
      </div>
    )
  }

  return (
    <div class="spotlight-feedback-view">
      <div class="spotlight-feedback-header">
        <button class="spotlight-back-btn" onClick={onBack}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          {WIDGET_CONFIG.copy.feedbackBack}
        </button>
        <span class="spotlight-feedback-title">{WIDGET_CONFIG.copy.feedbackTitle}</span>
      </div>
      <div class="spotlight-feedback-body">
        <textarea
          class="spotlight-feedback-textarea"
          placeholder={WIDGET_CONFIG.copy.feedbackPlaceholder}
          value={text}
          onInput={(e) => setText((e.target as HTMLTextAreaElement).value)}
          rows={4}
          autofocus
        />
        <button
          class="spotlight-feedback-submit"
          onClick={handleSubmit}
          disabled={!text.trim() || status === 'submitting'}
        >
          {status === 'submitting' ? WIDGET_CONFIG.copy.feedbackSubmitting : WIDGET_CONFIG.copy.feedbackSubmit}
        </button>
      </div>
    </div>
  )
}
